import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  const {
    t
  } = useLanguage();
  return <AnimatePresence data-id="element-176">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[60]" data-id="element-177" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} className="fixed inset-4 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl md:max-h-[80vh] bg-[#111118] border border-white/10 rounded-2xl shadow-2xl z-[61] flex flex-col overflow-hidden" data-id="element-178">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 flex-shrink-0" data-id="element-179">
              <h2 className="text-lg font-bold text-white" data-id="element-180">
                {t('footer_terms_title')}
              </h2>
              <button onClick={onClose} className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-colors" data-id="element-181">
                <X className="w-4 h-4" data-id="element-182" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto text-gray-300 text-sm leading-relaxed space-y-4 flex-1" data-id="element-183">
              <p className="text-gray-400 text-xs" data-id="element-184">
                {t('footer_terms_updated')}
              </p>

              <h3 className="text-white font-semibold text-base mt-4" data-id="element-185">
                {t('terms_section1_title')}
              </h3>
              <p data-id="element-186">{t('terms_section1_body')}</p>

              <h3 className="text-white font-semibold text-base mt-4" data-id="element-187">
                {t('terms_section2_title')}
              </h3>
              <p data-id="element-188">{t('terms_section2_body')}</p>

              <h3 className="text-white font-semibold text-base mt-4" data-id="element-189">
                {t('terms_section3_title')}
              </h3>
              <p data-id="element-190">{t('terms_section3_body')}</p>

              <h3 className="text-white font-semibold text-base mt-4" data-id="element-191">
                {t('terms_section4_title')}
              </h3>
              <p data-id="element-192">{t('terms_section4_body')}</p>

              <h3 className="text-white font-semibold text-base mt-4" data-id="element-193">
                {t('terms_section5_title')}
              </h3>
              <p data-id="element-194">{t('terms_section5_body')}</p>

              <h3 className="text-white font-semibold text-base mt-4" data-id="element-195">
                {t('terms_section6_title')}
              </h3>
              <p data-id="element-196">{t('terms_section6_body')}</p>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}